<template>
    <div class="loading-wrapper" :class="{ 'is-loading' : isLoading }">
        <div class="blocks-switch" v-if="useDeactivatedSwitch">
            <span class="label">
                {{ $t('filter_show_all') }}
                <label>
                    <input type="checkbox" value="1" v-model="showDeactivatedOnly" @change="onChangeShowDeactivatedOnly" />
                    <span></span>
                </label>
            </span>
        </div>
        <div :class="id + ' ' + id + '--overview'">
            <template v-if="rows.length === 0">
                <div :class="id + '--overview__empty-item'">
                    {{ emptyMessage }}
                </div>
            </template>
            <template v-else v-for="(row, index) in rows">
                <div :class="id + '--overview__item'">
                    <slot name="block" :row="row"></slot>
                </div>
            </template>
        </div>
        <div class="loading-message" v-if="isLoading">{{ $t('results_loading') }}</div>
    </div>
</template>

<script>
    export default {
        props : {
            id  : {
                type : String,
                default : ''
            },
            items : {
                type : Array,
                default : [],
            },
            isLoading : {
                type : Boolean,
                default : false
            },
            showDeactivatedOnly : {
                type : Number,
                default : 0
            },
            useDeactivatedSwitch: {
                type: Boolean,
                default: true
            }
        },
        data : function () {
            return {
                emptyMessage    : this.$t('no_results_found'),
                rows            : []
            };
        },
        watch : {
            items : function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.updateBlocks();
                }
            }
        },
        methods : {
            updateBlocks : function () {
                this.getBlockRows();
            },
            getBlockRows : function () {
                var rows = [];

                this.items.forEach(function(row) {
                    rows.push(row);
                }, this);

                this.rows = rows;
            },
            onChangeShowDeactivatedOnly : function (event) {
                this.$emit('onChangeShowDeactivatedOnly', event.target.checked ? 1 : 0);
            }
        }
    }
</script>